import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import CategoriaItem from './CategoriaItem';

export default function Categoria({ elem, notasPadre = null }) {

    return (
        elem ?
            <div style={{ marginTop: 4, marginBottom: 4 }}>
                <h4 style={{ margin: '0 0 3px 0', fontSize: 16, lineHeight: 1.2 }}>{elem.indice_completo} {elem.categoria.nombre}</h4>
                {elem.hijos &&
                    <CategoriaItem elem={elem} notasPadre={elem?.notas ?? notasPadre} />
                }
            </div>
            :
            <></>
    )
}